module.exports = __webpack_public_path__ + "img/OTP_check_ic_normal.7490d72.svg";